import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';
import { IEgaugeRegister } from '@/Core.Service.Domain/Monitors/Egauges/types/register';
import { IEgauge } from '@/Core.Service.Domain/Monitors/Egauges/types/egauge.ts';
import { IUnmappedRegisters } from '@/Core.Service.Domain/Monitors/Egauges/types/unmappedRegisters.ts';

import actions from '@/Core.Service.Domain/Monitors/Egauges/Store/actions.ts';
import getters from '@/Core.Service.Domain/Monitors/Egauges/Store/getters.ts';
import mutations from '@/Core.Service.Domain/Monitors/Egauges/Store/mutations.ts';

const state = {
  selectedSite: {} as ISite,
  registersList: [] as IEgaugeRegister[],
  egaugeInfo: {} as IEgauge,
  unmappedRegisters: {} as IUnmappedRegisters,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
